/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MembersIcon = /*#__PURE__*/ createSvgIcon(
  'MembersIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.29 9.502a4.21 4.21 0 014.538 4.539.5.5 0 01-.498.459H12v-1h2.836a3.208 3.208 0 00-3.465-3.002l-.082-.996zM2.431 8.89a.5.5 0 01.572.067 3.5 3.5 0 004.664 0 .5.5 0 01.583-.06c.599.346 1.203.74 1.626 1.536.413.775.624 1.873.624 3.567h-1c0-1.636-.209-2.538-.507-3.098-.233-.439-.54-.704-.948-.962a4.5 4.5 0 01-5.426-.005c-.404.245-.709.51-.942.95-.298.566-.507 1.48-.507 3.115h-1c0-1.694.211-2.801.623-3.58.424-.805 1.03-1.199 1.638-1.53zM12 4.5c-.833 0-1.5.667-1.5 1.48s.667 1.48 1.5 1.48 1.5-.667 1.5-1.48A1.49 1.49 0 0012 4.5zM9.5 5.98A2.49 2.49 0 0112 3.5a2.49 2.49 0 012.5 2.48A2.49 2.49 0 0112 8.46a2.49 2.49 0 01-2.5-2.48zM5.33 3.16a2.17 2.17 0 100 4.34 2.17 2.17 0 000-4.34zM2.16 5.33a3.17 3.17 0 116.34 0 3.17 3.17 0 01-6.34 0z"
            fill="currentColor"
          />
        </>
      ),
      medium: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.13 11.502a5.14 5.14 0 015.538 5.538.5.5 0 01-.498.46H15v-1h3.683a4.14 4.14 0 00-4.473-4.002l-.08-.996zM9.672 10.792a.5.5 0 01.565-.062c.754.405 1.485.88 1.999 1.85.5.946.764 2.306.764 4.42h-1c0-2.056-.261-3.221-.648-3.952-.32-.606-.747-.954-1.3-1.276a5.59 5.59 0 01-6.766.005c-.556.342-.984.69-1.305 1.291-.387.725-.65 1.877-.65 3.932h-1c0-2.115.265-3.463.768-4.403.514-.962 1.244-1.435 1.981-1.86a.5.5 0 01.578.055 4.59 4.59 0 006.014 0zM15 4.5c-1.11 0-2 .888-2 1.97 0 1.082.89 1.97 2 1.97 1.11 0 2-.888 2-1.97 0-1.082-.89-1.97-2-1.97zm-3 1.97c0-1.646 1.349-2.97 3-2.97s3 1.324 3 2.97c0 1.646-1.349 2.97-3 2.97s-3-1.324-3-2.97zM6.67 2.84a2.83 2.83 0 100 5.66 2.83 2.83 0 000-5.66zM2.84 5.67a3.83 3.83 0 117.66 0 3.83 3.83 0 01-7.66 0z"
            fill="currentColor"
          />
        </>
      ),
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.912 16.434C23.001 17.639 23.5 19.268 23.5 21a.5.5 0 01-.5.5h-5v-1h4.484c-.087-1.342-.526-2.524-1.314-3.395-.876-.968-2.232-1.605-4.17-1.605v-1c2.172 0 3.816.723 4.912 1.934zM3.762 13.56a.5.5 0 01.567.063 5.58 5.58 0 007.342 0 .5.5 0 01.567-.063c.899.486 1.754 1.045 2.357 2.184.589 1.115.905 2.727.905 5.256h-1c0-2.47-.314-3.889-.79-4.789-.407-.771-.955-1.205-1.655-1.608a6.58 6.58 0 01-8.11 0c-.7.403-1.248.837-1.655 1.608-.476.9-.79 2.318-.79 4.789h-1c0-2.53.316-4.141.905-5.256.603-1.14 1.458-1.698 2.357-2.184zM18 6.5c-1.386 0-2.5 1.11-2.5 2.47s1.114 2.47 2.5 2.47 2.5-1.11 2.5-2.47S19.386 6.5 18 6.5zm-3.5 2.47c0-1.921 1.572-3.47 3.5-3.47s3.5 1.549 3.5 3.47c0 1.921-1.572 3.47-3.5 3.47s-3.5-1.549-3.5-3.47zM8 4.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM3.5 8a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default MembersIcon;
